module.exports = __webpack_public_path__ + "static/media/saturday.b0a9953b.ogg";